function preparePlugins(container)
{
    container.find('.inp-checkbox-wrap').customCheckboxes();
}

function flashMessages()
{

    FLASHESS.forEach(function (v, k) {
        toastr[v.type](v.message);
    });

    FLASHESS.length = 0;
}

function setSeznamMapMarkers(seznamMap, markers = [])
{

    seznamMap.addControl(new SMap.Control.Sync());
    seznamMap.addDefaultLayer(SMap.DEF_BASE).enable();

    let mouseEvents = new SMap.Control.Mouse(SMap.MOUSE_PAN | SMap.MOUSE_WHEEL | SMap.MOUSE_ZOOM); /* Ovládání myší */
    seznamMap.addControl(mouseEvents);

    let coordinations = [];
    let mapMarkers = [];

    for (let i = 0; i < markers.length; i++) {

        let markerCoordination = SMap.Coords.fromWGS84(markers[i][2], markers[i][1]);

        let markerOptions = {
            url: DESIGN_PATH + '/marker.png?v=1'
        };

        let markerCard = new SMap.Card();
        markerCard.getBody().innerHTML = markers[i][0];

        let marker = new SMap.Marker(markerCoordination, null, markerOptions);
        marker.decorate(SMap.Marker.Feature.Card, markerCard);

        coordinations.push(markerCoordination);
        mapMarkers.push(marker);
    }

    let markersLayer = new SMap.Layer.Marker();
    seznamMap.addLayer(markersLayer);
    markersLayer.enable();

    for (let mapMarker of mapMarkers) {
        markersLayer.addMarker(mapMarker);
    }

    let centerZoom = seznamMap.computeCenterZoom(coordinations);
    seznamMap.setCenterZoom(centerZoom[0], centerZoom[1]);
}

function initSeznamMapWhenNeeded(element, locations)
{

    if ($(window).scrollTop() + $(window).height() >= element.offset().top) {
        element.data('map-initialized', true);
        let seznamMap = new SMap(JAK.gel(element.get(0)));
        setSeznamMapMarkers(seznamMap, locations);
    } else {
        $(window).on('scroll', function () {
            if ($(window).scrollTop() + $(window).height() >= element.offset().top) {
                if (!isDefined(element.data('map-initialized'))) {
                    element.data('map-initialized', true);
                    let seznamMap = new SMap(JAK.gel(element.get(0)));
                    setSeznamMapMarkers(seznamMap, locations);
                }
            }
        });
    }

}

$(document).ready(function () {

    preparePlugins($(document));
    flashMessages();

    let options = {
        theme: "default",
        position: "bottom",
        distance: 20,
        borderRadius: 4,
        background: "#e9f5fb",
        backgroundOpacity: "1",
        fontSize: 14,
        text: "Tyto webové stránky používají k poskytování svých služeb soubory Cookies. Používáním těchto webových stránek souhlasíte s použitím souborů Cookies.",
        html: false,
        textColor: "#14236d",
        showButton: true,
        buttonText: "OK!",
        buttonColor: "#14236d",
        buttonBgColor: "#fff",
        moreButtonText: "Více informací o Cookies",
        moreButtonColor: "#14236d",
        moreButtonLink: "https://www.cookie-lista.cz/co-je-cookies.html",
        showCloseButton: false,
        cookieDays: 365
    };

    $("body").BeeCookie(options);

    $("#send-contact-form").on("click", function (e1) {

        let btn = $(this);

        $(this).closest("form").submit(function (e2) {

            if (e2.isDefaultPrevented()) {
                return false;
            }

            let formData = new FormData(this);
            e1.preventDefault();
            e2.preventDefault();

            let textarea = $(this).find("textarea");
            if (textarea.val() === 'Zpráva *') {
                textarea.val("");
                textarea.focus().blur();
                textarea.val('Zpráva *');
                return false;
            }

            btn.prop('disabled', true);

            let formUrl = $(this).attr("action");

            grecaptcha.ready(function () {
                grecaptcha.execute(RECAPTCHA_PUBLIC_KEY, {action: 'homepage'}).then(function (token) {

                    formData.append('token', token);
                    formData.append('action', 'homepage');

                    $.nette.ajax({
                        url: formUrl,
                        data: formData,
                        type: 'POST',
                        processData: false,
                        contentType: false,
                        success: function (payload) {

                        },
                        off: {
                            snippets: true
                        }
                    });
                });
            });

        });

    });

    $('input[type="text"], input[type="email"]').on("focus", function () {
        $(this).data('placeholder', $(this).attr('placeholder'));
        $(this).attr('placeholder', '');
    }).on("blur", function () {
        $(this).attr('placeholder', $(this).data('placeholder'));
    });

    $("textarea").on("focus", function () {
        $(this).removeClass('placeholder');
        if ($(this).val() === 'Poznámka *') {
            $(this).val('');
        }
    });
    $("textarea").on("blur", function () {
        if ($(this).val() === "") {
            $(this).val('Poznámka *');
        }
        if ($(this).val() === 'Poznámka *') {
            $(this).addClass('placeholder');
        }
    });

    // Menu

    let topLine = $('.top-line');
    let contacts = $('.contacts-bar');
    let main = $('main');

    if ($(window).scrollTop() > 0) {
        topLine.addClass('fixed');
        setTimeout(function () {
            contacts.addClass('fixed').css('top', topLine.outerHeight());
            main.css('padding-top', contacts.outerHeight() + topLine.outerHeight());
        }, 401);
    }

    $(window).on('scroll resize', function (e) {

        if ($(window).scrollTop() > 0) {
            topLine.addClass('fixed');
            contacts.addClass('fixed').css('top', topLine.outerHeight());
            main.css('padding-top', contacts.outerHeight() + topLine.outerHeight());

            setTimeout(function () {
                contacts.css('top', topLine.outerHeight());
                main.css('padding-top', contacts.outerHeight() + topLine.outerHeight());
            }, 401);

        } else {
            setTimeout(function () {
                topLine.removeClass('fixed');
                contacts.removeClass('fixed').css('top', 0);
                main.css('padding-top', 0);
            }, 401);
        }

        let mainMenu = $('#main-menu');
        if (window.matchMedia('(min-width: 1201px)').matches) {
            mainMenu.css({
                'top': 'unset',
                'height': 'unset'
            });
        } else {
            if (mainMenu.hasClass('visible')) {
                mainMenu.css({
                    'top': contacts.outerHeight() + topLine.outerHeight(),
                    'height': $(window).height() - contacts.outerHeight() + topLine.outerHeight()
                });
            }
        }

    });

    $(document).on('click', '.navbar .hamburger', function (e) {

        let target = $(this).data("target");

        if (isDefined(target)) {

            target = $(document).find(target);
            $(this).toggleClass('active');

            target.css({
                'top': contacts.outerHeight() + topLine.outerHeight(),
                'height': $(window).height() - contacts.outerHeight() + topLine.outerHeight()
            });

            let nowVisible = target.hasClass('visible');

            if (nowVisible) {
                target.removeClass('visible');
            } else {
                target.addClass('visible');
            }

        }

    });

    $(document).on('touchend', '.reference a', function (e) {

        $(this).closest('.reference').siblings().each(function () {
            $(this).find('a').removeClass('hover').data('is-touched', false);
        });

        if (!isDefined($(this).data('is-touched'))) {
            $(this).data('is-touched', false);
        }

        if (!$(this).data('is-touched')) {
            e.preventDefault();
            $(this).data('is-touched', true).addClass('hover');
        }

    });


    $.nette.init();

    $.nette.ext({
        complete: function (payload) {
            preparePlugins($("body"));
            flashMessages();
        }
    });

});